import {generateRoutePath} from 'epic-ue-locale-mode';
import {Grid} from '@material-ui/core';
import {Typography, ArrowRight} from 'epic-ue-ui';
import React from 'react';
import {Link} from 'react-router-dom';
import {JobProps} from './jobs.fetch';
import {SpotlightIcon} from './SpotlightIcon';
import {useBreakpointDown, useBreakpointUp} from 'epic-ue-theme';
import {getNoFunctionalQueryStringified} from './jobs.utils';

interface Props {
    jobs?: JobProps[];
    countryFilter?: string[];
    noResults?: string;
    isLoading?: boolean;
    spotlightHoverLabel?: string;
    maintenanceMsg?: string;
}

const noVerticalPadding = {paddingTop: 0, paddingBottom: 0};
const stringifiedQueryParams = getNoFunctionalQueryStringified();

export const JobList = ({
    isLoading,
    jobs,
    noResults,
    spotlightHoverLabel,
    maintenanceMsg
}: Props): JSX.Element => {
    const isMd = useBreakpointDown('md');
    const isLg = useBreakpointUp('lg');

    if (maintenanceMsg) {
        return <Typography className="maintenance" variant="h3">{maintenanceMsg}</Typography>;
    }

    if (!isLoading && (!jobs || !jobs.length)) {
        return <h3 className="no-results">{noResults || 'No results'}</h3>;
    }

    return (
        <>
            {jobs && jobs.length
                ? jobs.map((job) => {
                      return (
                          <Link
                              to={generateRoutePath(
                                  `careers/jobs/${job?.id}?${stringifiedQueryParams}`
                              )}
                              key={job?.id}>
                              <Grid
                                  className="filtered-result-row"
                                  container
                                  direction="row"
                                  justifyContent="center"
                                  alignItems="center"
                                  spacing={3}>
                                  {isMd && (
                                      <Grid item xs={1} sm={1} md={1}>
                                          <Typography className="joblisting-spotlight" variant="p">
                                              {job?.spotlight && (
                                                  <SpotlightIcon hoverLabel={spotlightHoverLabel} />
                                              )}
                                          </Typography>
                                      </Grid>
                                  )}
                                  <Grid
                                      item
                                      xs={11}
                                      sm={11}
                                      md={11}
                                      lg={4}>
                                      <Grid
                                          container
                                          direction="row"
                                          justifyContent="center"
                                          spacing={3}>
                                          {isLg && (
                                              <Grid item lg={1}>
                                                  <Typography
                                                      className="joblisting-spotlight"
                                                      variant="p">
                                                      {job?.spotlight && (
                                                          <SpotlightIcon
                                                              hoverLabel={spotlightHoverLabel}
                                                          />
                                                      )}
                                                  </Typography>
                                              </Grid>
                                          )}
                                          <Grid item xs={12} lg={11}>
                                              <Typography className="joblisting-title" variant="p">
                                                  {job?.title}
                                              </Typography>
                                          </Grid>
                                      </Grid>
                                  </Grid>

                                  {!isMd && (
                                      <>
                                          <Grid item xs={4} sm={4} md={2}>
                                              <Typography variant="p">{job?.company}</Typography>
                                          </Grid>
                                          <Grid item xs={4} sm={4} md={3}>
                                              <Typography variant="p">{job?.department}</Typography>
                                          </Grid>{' '}
                                      </>
                                  )}

                                  {isMd ? (
                                      <Grid item xs={10} sm={10} md={10} style={noVerticalPadding}>
                                          <div className="joblisting-details-sm">
                                              {job?.company} | {job?.department} |{' '}
                                              {job?.city?.length > 1 ? "Multiple locations" : job?.city.map((v, k) => {
                                                  const str = [job?.country[k]]
                                                  if (v.toLocaleLowerCase() !== "blank") {
                                                      str.unshift(v);
                                                  }
                                                  return str.join(", ");
                                              })}
                                          </div>
                                      </Grid>
                                  ) : (
                                      <>
                                          <Grid item xs={4} sm={4} md={2}>
                                              <Typography variant="p">
                                                  {job?.city?.length > 1 ? "Multiple locations" : job?.city.map((v, k) => {
                                                      const str = [job?.country[k]]
                                                      if (v.toLocaleLowerCase() !== "blank") {
                                                          str.unshift(v);
                                                      }
                                                      return str.join(", ");
                                                  })}
                                              </Typography>
                                          </Grid>
                                          <Grid item md={1}>
                                              <div className="rightCarret">
                                                  <ArrowRight />
                                              </div>
                                          </Grid>
                                      </>
                                  )}
                              </Grid>
                          </Link>
                      );
                  })
                : ''}
        </>
    );
};
